import React from "react";

const WebAccessibility = (props) => {
    return (
        <>
        <div className={`column is-flex is-flex-direction-column ${props.className}`}>
            <h1 className="h1 colorBlack">{props.title}</h1>
            <p className="subtitle colorBlack"><span className="is-bold">Last Updated:</span> {props.effectiveDate}</p>
            <p>At Kinder’s Meats, we are committed to ensuring that our website is accessible to all individuals, including those with disabilities. We strive to meet or exceed the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA, as published by the World Wide Web Consortium (W3C).</p>

            <h2 className="h2">Accessibility Features</h2>
            <p>Consistent navigation and semantic HTML structure</p>
            <ul>
                <li>Text alternatives for non-text content (e.g., images with alt attributes)</li>
                <li>Keyboard-accessible navigation</li>
                <li>Sufficient color contrast between text and backgrounds</li>
            </ul>

            <h2 className="h2">Third-Party Content</h2>
            <p>Some pages may contain content from third-party providers (e.g., Heartland POS, DoorDash) that are not fully under our control. While we strive to ensure accessible integrations, we cannot guarantee the accessibility of external platforms.</p>

            <h2 className="h2">Feedback and Support</h2>
            <p>If you experience difficulty accessing any part of the Site, encounter accessibility barriers, or have suggestions for improvement, please contact:</p>

            <h3 className="h3">Mailing Address</h3> 
            <p>JDK & Company, Inc.<br />
            1150 Burnett Ave., Suite D<br />
            Concord, CA 94520<br />
            Email: <a href="mailto:corporate@kinderscorp.com">corporate@kinderscorp.com</a><br />
            Phone: <a href="tel:+19253637367">(925) 363-7367</a></p>
        </div>
        </>
    );

}

export default WebAccessibility;